<template>
  <div>
    <v-btn @click="openDialog">Consume Items</v-btn>
    <v-dialog v-model="dialog" persistent width="1200">
      <v-card>
        <v-card-title>Consume Items</v-card-title>
        <v-card-text>
          <v-tabs v-model="activeTab">
            <v-tab>Items</v-tab>
            <v-tab>Consume History</v-tab>
          </v-tabs>

          <v-tabs-items v-model="activeTab">
            <!-- Items Tab -->
            <v-tab-item>
              <h3 class="mt-4">Items Table</h3>
              <v-row align="center">
                <v-col>
                  <v-text-field
                    v-model="search"
                    prepend-icon="mdi-magnify"
                  ></v-text-field>
                </v-col>
                <v-col cols="auto">
                  <v-btn color="primary" outlined @click="openSerialScan">
                    <v-icon left>mdi-barcode-scan</v-icon>
                    Scan Serial
                  </v-btn>
                </v-col>
              </v-row>
              <v-data-table
                :search="search"
                :headers="headers"
                :items="items"
                class="elevation-1"
              >
                <template v-slot:item.actions="{ item }">
                  <v-btn color="primary" small @click="selectconsume(item)">
                    <v-icon class="mr-2">mdi-plus-circle</v-icon> Add
                  </v-btn>
                </template>
                <template v-slot:item.status="{ item }">
                  <span :class="item.status === 'consume' ? 'red--text' : ''">{{
                    item.status
                  }}</span>
                </template>
              </v-data-table>
            </v-tab-item>

            <!-- Consume History Tab -->
            <v-tab-item>
              <h3 class="mt-4">Consume History</h3>
              <v-text-field
                v-model="historySearch"
                prepend-icon="mdi-magnify"
                placeholder="Search history..."
              ></v-text-field>
              <v-data-table
                :search="historySearch"
                :headers="historyHeaders"
                :items="consumeHistory"
                :loading="historyLoading"
                class="elevation-1"
              >
                <template v-slot:item.total_amount="{ item }">
                  {{ formatCurrency(item.total_amount) }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    color="error"
                    small
                    @click="confirmRevert(item)"
                    :loading="revertingId === item.id"
                  >
                    <v-icon class="mr-1">mdi-delete</v-icon> Revert
                  </v-btn>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog = false"> Close</v-btn>
          <v-spacer></v-spacer>
          <p class="caption grey--text">consumeItemsModal.vue</p>
        </v-card-actions>
      </v-card>

      <!-- add consume item -->

      <v-dialog v-model="consumeDialog" width="500">
        <v-card>
          <v-card-title>Add Consume Item</v-card-title>
          <v-card-text>
            <v-form>
              <v-text-field
                label="Item Name"
                v-model="selectedItem.item_name"
              ></v-text-field>
              <v-text-field
                readonly
                label="Batch"
                v-model="selectedItem.import_batch.batch_description"
              ></v-text-field>
              <v-text-field
                readonly
                label="Available Stock"
                v-model="selectedItem.available_quantity"
              ></v-text-field>
              <v-text-field
                v-if="selectedItem.serial_number"
                readonly
                label="Serial Number"
                v-model="selectedItem.serial_number"
                prepend-icon="mdi-barcode"
              ></v-text-field>
              <v-text-field
                label="Quantity to Consume"
                type="number"
                min="1"
                :max="selectedItem.available_quantity"
                :readonly="!!selectedItem.serial_number"
                :hint="
                  selectedItem.serial_number
                    ? 'Consuming by serial consumes exactly 1 unit.'
                    : ''
                "
                persistent-hint
                v-model.number="selectedItem.consume_quantity"
              ></v-text-field>
              <v-text-field
                label="Reason"
                v-model="selectedItem.remarks"
              ></v-text-field>
              <v-select
                :items="paymentMethods"
                label="Account Title"
                v-model="selectedItem.chart_of_account_id"
                item-text="account_title"
                item-value="id"
              >
              </v-select>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="submit()">Submit</v-btn>
            <v-btn @click="consumeDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- scan serial to consume -->
      <v-dialog v-model="serialScanDialog" max-width="520">
        <v-card>
          <v-card-title>
            <v-icon left color="primary">mdi-barcode-scan</v-icon>
            Scan Serial to Consume
            <v-spacer></v-spacer>
            <v-btn icon @click="serialScanDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="serialScanInput"
              ref="serialScanField"
              label="Scan or type a serial number"
              placeholder="Scan here, then press Enter"
              prepend-inner-icon="mdi-barcode-scan"
              outlined
              dense
              clearable
              autofocus
              hide-details
              :loading="serialScanLoading"
              @keyup.enter="scanSerial"
            ></v-text-field>
            <div
              v-if="serialScanFeedback"
              class="caption mt-2"
              :class="
                serialScanFeedbackType === 'success'
                  ? 'green--text'
                  : 'red--text'
              "
            >
              <v-icon
                x-small
                :color="serialScanFeedbackType === 'success' ? 'green' : 'red'"
                >{{
                  serialScanFeedbackType === "success"
                    ? "mdi-check-circle"
                    : "mdi-alert-circle"
                }}</v-icon
              >
              {{ serialScanFeedback }}
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="serialScanDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  data() {
    return {
      activeTab: 0,
      paymentMethods: [
        { id: 33, account_title: "Consumable Office Supplies" },
        { id: 23, account_title: "Office Equipment" },
      ],
      selectedItem: {
        item_name: "",
        import_batch: {
          batch_description: "",
        },
        chart_of_account_id: 33,
        quantity: 0,
        remarks: "",
      },
      consumeDialog: false,
      serialScanDialog: false,
      serialScanInput: "",
      serialScanLoading: false,
      serialScanFeedback: "",
      serialScanFeedbackType: "success",
      search: "",
      historySearch: "",
      dialog: false,
      loading: false,
      historyLoading: false,
      revertingId: null,
      consumeHistory: [],
      headers: [
        { text: "Actions", value: "actions", sortable: false },
        { text: "Item Name", value: "item_name" },
        { text: "Batch", value: "import_batch.batch_description" },
        { text: "Quantity", value: "quantity" },
      ],
      historyHeaders: [
        { text: "Item Name", value: "item_name" },
        { text: "Quantity", value: "quantity" },
        { text: "Serial", value: "serial_number" },
        { text: "Total Amount", value: "total_amount" },
        { text: "Type", value: "type" },
        { text: "Reason", value: "reason" },
        { text: "Processed By", value: "processed_by" },
        { text: "Date", value: "created_at" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters({
      items: "item/items",
      chart_of_accounts: "chart_of_account/chart_of_accounts",
    }),
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat("en-PH", {
        style: "currency",
        currency: "PHP",
      }).format(value);
    },
    async openDialog() {
      this.dialog = true;
      await this.fetchConsumeHistory();
    },
    async fetchConsumeHistory() {
      this.historyLoading = true;
      try {
        let response = await axios.get("/consume_history");
        this.consumeHistory = response.data;
      } catch (error) {
        console.error("Error fetching consume history:", error);
      } finally {
        this.historyLoading = false;
      }
    },
    async submit() {
      const quantity = Number(this.selectedItem.consume_quantity);

      // Client-side validation: positive whole number, not over available stock
      if (!Number.isInteger(quantity) || quantity <= 0) {
        this.$alert({
          title: "Invalid quantity",
          message: "Please enter a whole quantity greater than zero.",
          color: "error",
          icon: "mdi-alert-circle",
        });
        return;
      }
      if (quantity > Number(this.selectedItem.available_quantity)) {
        this.$alert({
          title: "Insufficient stock",
          message: `Only ${this.selectedItem.available_quantity} units are available.`,
          color: "error",
          icon: "mdi-alert-circle",
        });
        return;
      }

      let confirmed = await this.$confirm({
        title: "Consume Item",
        message:
          `Are you sure you want to consume ${quantity} of ${this.selectedItem.item_name}?` +
          (this.selectedItem.serial_number
            ? `<br>Serial: ${this.selectedItem.serial_number}`
            : ""),
        color: "primary",
        icon: "mdi-help-circle-outline",
      });
      if (!confirmed) return;

      this.loading = true;
      try {
        await axios.post("/consume_item", {
          item_id: this.selectedItem.id,
          quantity: quantity,
          remarks: this.selectedItem.remarks,
          chart_of_account_id: this.selectedItem.chart_of_account_id,
          serial_number: this.selectedItem.serial_number || undefined,
        });
        this.consumeDialog = false;
        this.$alert({
          title: "Success",
          message: "Item consumed successfully",
          color: "success",
          icon: "mdi-check-circle",
        });
        // Refresh history after consuming
        await this.fetchConsumeHistory();
        // Refresh items list
        this.$store.dispatch("item/get_items");
      } catch (error) {
        console.error("Error consuming item:", error);
        this.$alert({
          title: "Error",
          message:
            error.response?.data?.message ||
            error.response?.data?.error ||
            "Failed to consume item. Please try again.",
          color: "error",
          icon: "mdi-alert-circle",
        });
      } finally {
        this.loading = false;
      }
    },
    selectconsume(item) {
      // Keep the item's real stock separate from the amount being consumed so
      // the quantity field doesn't default to the entire available stock.
      this.selectedItem = {
        ...item,
        available_quantity: item.quantity,
        consume_quantity: 1,
        remarks: "",
        serial_number: "",
      };
      this.consumeDialog = true;
    },
    openSerialScan() {
      this.serialScanInput = "";
      this.serialScanFeedback = "";
      this.serialScanDialog = true;
      this.$nextTick(() => {
        if (this.$refs.serialScanField) this.$refs.serialScanField.focus();
      });
    },
    async scanSerial() {
      const serial = (this.serialScanInput || "").trim().toUpperCase();
      if (!serial) return;

      this.serialScanLoading = true;
      this.serialScanFeedback = "";
      try {
        const response = await axios.get("/item_by_serial", {
          params: { serial },
        });
        const item = response.data.item;
        this.selectedItem = {
          ...item,
          available_quantity: item.quantity,
          consume_quantity: 1,
          remarks: "",
          serial_number: response.data.serial_number,
        };
        this.serialScanDialog = false;
        this.consumeDialog = true;
      } catch (error) {
        this.serialScanFeedbackType = "error";
        this.serialScanFeedback =
          error.response?.data?.error ||
          "Failed to look up serial. Please try again.";
        this.$nextTick(() => {
          if (this.$refs.serialScanField) this.$refs.serialScanField.focus();
        });
      } finally {
        this.serialScanLoading = false;
      }
    },
    async confirmRevert(item) {
      let confirmed = await this.$confirm({
        title: "Revert Consume Transaction",
        message: `Are you sure you want to revert this consume transaction?<br><br>Item: ${item.item_name}<br>Quantity: ${item.quantity}<br><br>This will:<br>1. Delete the journal entries<br>2. Restore the item quantity`,
        color: "orange",
        icon: "mdi-alert",
      });

      if (confirmed) {
        await this.revertConsumeItem(item);
      }
    },
    async revertConsumeItem(item) {
      this.revertingId = item.id;
      try {
        let response = await axios.post("/revert_consume_item", {
          consumed_item_id: item.id,
        });

        if (response.data.success) {
          this.$alert({
            title: "Success",
            message: "Consume transaction reverted successfully",
            color: "success",
            icon: "mdi-check-circle",
          });
          // Refresh history
          await this.fetchConsumeHistory();
          // Refresh items list
          this.$store.dispatch("item/get_items");
        } else {
          this.$alert({
            title: "Error",
            message:
              "Failed to revert: " + (response.data.error || "Unknown error"),
            color: "error",
            icon: "mdi-alert-circle",
          });
        }
      } catch (error) {
        console.error("Error reverting consume item:", error);
        this.$alert({
          title: "Error",
          message:
            "Failed to revert consume transaction: " +
            (error.response?.data?.error || error.message),
          color: "error",
          icon: "mdi-alert-circle",
        });
      } finally {
        this.revertingId = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
